import { GRAY_LIGHT } from './mc-tokens';

export const MODUS_TREE_MENU_STYLESHEET = `
modus-wc-tree-menu {
  & .modus-wc-menu-item {
    background-color: transparent;
    &:hover {
      background-color: ${GRAY_LIGHT};
      cursor: pointer;
    }
  }

  & modus-wc-tree-item .modus-wc-menu-item-labels {
    padding-inline-start: var(--modus-wc-spacing-xs) !important;
  }
}
`;
